import { toast } from "react-toastify";
import { fetchCreatePolicyFailure, fetchCreatePolicySuccess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { CREATE_POLICY_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

export const createSettlementPolicy = (jsonObj, setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${CREATE_POLICY_API}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            setLoading(false)
            dispatch(fetchCreatePolicySuccess(response))
            navigate('/policy');
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            dispatch(fetchCreatePolicyFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}